const type = 'SET_CLIENT_ID';

const setClientId = (data) => ({
  data,
  type,
});

export { type };
export default setClientId;
